import React from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { translationMessages } from 'containers/LanguageProvider/intl';
import get from 'lodash/get';
import { makeSelectLocale } from 'containers/LanguageProvider/selectors';
import { createStructuredSelector } from 'reselect';

const messages = translationMessages;

interface LanguageProviderProps {
  locale: string;
}

const LanguageProvider: React.FC<LanguageProviderProps> = (
  props,
): JSX.Element => {
  return (
    <IntlProvider locale={props.locale} messages={get(messages, props.locale)}>
      {React.Children.only(props.children)}
    </IntlProvider>
  );
};

const mapStateToProps = createStructuredSelector({
  locale: makeSelectLocale(),
});

export default connect(mapStateToProps)(LanguageProvider);
